import service from './request'

export const postRegister = data=>{
  return service({
    url: '/addons/shopro/user/register',
    method: 'post',
    data
  })
}

export const getPersonInfo = data => {
    return service({
        url: '/addons/shopro/index/init',
        method: 'get',
        data
    })
};

export const postUserLogin = data=>{
    return service({
        url: '/addons/shopro/user/accountLogin',
        method: 'post',
        data
    })
}

export const postMobileLogin = data=>{
    return service({
        url: '/addons/shopro/user/smsLogin',
        method: 'post',
        data
    })
}

export const changePwd = data=>{
    return service({
        url: '/addons/shopro/user/changePwd',
        method:'post',
        data
    })
}
export const forgotPwd = data=>{
  return service({
    url: '/addons/shopro/user/forgotPwd',
    method:'post',
    data
  })
}

export const bindMobile = data=>{
    return service({
        url: 'addons/shopro/user/bindMobile',
        method:'post',
        data
    })
}

export const sendChangeMobileCaptcha = mobile =>{
    return service({
        url: '/addons/shopro/sms/send',
        method: 'post',
        data: {mobile: mobile, event: "changemobile"},
    })
}

export const sendMobileCaptcha = data =>{
    return service({
        url: '/addons/shopro/sms/send',
        method: 'post',
        data
    })
}

export const getUserAddress = data=>{
    return service({
        url: '/addons/shopro/address',
        method: 'get',
    })
}

export const recharge = data=>{
    return service({
        url: '/addons/recharge/api.recharge/submit',
        method: 'POST',
        data
    })
}


export const preOrder = data=>{
    return service({
        url: '/addons/shopro/order/pre',
        method: 'post',
        data
    })
}

export const createOrder = data=>{
    return service({
        url: '/addons/shopro/order/createOrder',
        method: 'post',
        data
    })
}

export const prePay = data=>{
    return service({
        url: '/addons/shopro/pay/prepay',
        method: 'post',
        data
    })
}

export const addFav = data=>{
    return service({
        url: '/addons/shopro/goods/favorite',
        method: 'post',
        data
    })
}

// 获取fav收藏列表
export const getFavList = params =>{
    return service({
        url: '/addons/shopro/goods/favoriteList',
        method: 'get',
        params: params
    })
}

// 获取优惠券列表
export const getCouponList = params=>{
    return service({
        url: '/addons/shopro/coupons',//?type=[0|1|2|3]',
        method: 'get',
        params: params,
    })
}

// 获取已开票的列表
export const getInvoiceList = params=>{
    return service({
        url: '/addons/shopro/invoice/lists',
        method: 'get',
        params: params
    })
}

// 获取发票订单列表
export const getOrderForInvoice = params=>{
    return service({
        url: '/addons/shopro/order/getOrderInstalmentForInvoice', // page=1
        method: 'get',
        params: params
    })
}

// 获取订单列表
export const getOrderList = params=>{
    return service({
        url: '/addons/shopro/order/index', // page=1, type=[all|nopay|nosend|noget|nocomment]
        method: 'get',
        params: params
    })
}

// 获取分歧的 订单明细 getOrderInstalmentByUserId
export const getOrderInstalments = params=>{
    return service({
        url: '/addons/shopro/order/getOrderInstalmentByUserId', // page=1, type=[all|nopay|nosend|noget|nocomment]
        method: 'get',
        params: params
    })
}
// 获取名下的设备数量（按状态分类）
export const getMyDeviceStatusCount = params =>{
    return service({
        url: '/addons/shopro/device/countByStatus', // page=1, type=[all|nopay|nosend|noget|nocomment]
        method: 'get',
        params: params
    })
}

// 获取扣费订单列表
export const getOrderInstalmentForPc = params =>{
    return service({
        url: '/addons/shopro/order/getOrderInstalmentForPc', // page=1, type=[all|nopay|nosend|noget|nocomment]
        method: 'get',
        params: params
    })
}

export const getArea = ()=>{
    return service({
        url:'/addons/shopro/address/area',
        method: 'get',
    })
}

export const getOrderDetail = params=>{

    return service({
        url: '/addons/shopro/order/detail', // id=?
        method: 'get',
        params: params
    })
}

export const deleteOrder = params=>{
    return service({
        url: '/addons/shopro/order/delete', // id=?
        method: 'post',
        data: params // {id: 147}
    })
}

export const getFaxList = params=>{
    return service({
        url: '/addons/shopro/invoice/lists', // page=?
        method: 'get',
        params: params // {page: 1}
    })
}

export const getPayedOrderInstalmentList = params =>{
    return service({
        url: '/addons/shopro/order/getOrderInstalmentForInvoice', // page=?
        method: 'get',
        params: params // {page: 1}
    })
}

export const applyInvoice = params=>{
    return service({
        url: '/addons/shopro/invoice/add', // id=?
        method: 'post',
        data: params // {id: 147}
    })
}

// 更新地址，负责添加
export const updateUserAdress = params=>{
    return service({
        url: '/addons/shopro/address/edit', // id=?
        method: 'post',
        data: params // {id: 147}
    })
}

// 删除地址
export const delUserAddress = params=>{
    return service({
        url: '/addons/shopro/address/del', // id=?
        method: 'post',
        data: params // {id: 147}
    })
}



// WEBPACK FOOTER //
// ./src/axios/api.js